import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Tab, Tabs } from 'react-bootstrap';
import { Hyper } from '../../../../layout';
import Unlaunched from './Unlaunched';
import LaunchStats from './LaunchStats';
import RandomData from './RandomData';
import classes from './Dashboard.scss';

export default class Dashboard extends React.Component {
  static propTypes = {
    stats: PropTypes.object,
  };

  renderStats() {
    const { stats } = this.props;

    return (
      <Tabs defaultActiveKey={1} id="hyper-dashboard-tabs">
        <Tab eventKey={1} title="Websites">
          <LaunchStats {...stats} />
        </Tab>
        <Tab eventKey={2} title="Unlaunched Websites">
          <Unlaunched {...stats} />
        </Tab>
        <Tab eventKey={3} title="Platform Data">
          <RandomData {...stats} />
        </Tab>
      </Tabs>
    );
  }

  render() {
    const { stats } = this.props;

    return (
      <Hyper title="Command Center" dashboard={{ active: true }}>
        <Helmet title="Command Center" />

        <div className={classes.container}>
          {stats ? this.renderStats() : 'Loading...'}
        </div>
      </Hyper>
    );
  }
}
